import { Input, Modal, ModalBody } from "reactstrap";
import { cleanRut, formatRut } from "rutlib/lib";
import { useRecoilValue } from "recoil";

import { ButtonLoading } from "../../../../components/buttons/button-loading";
import { crudCollaboratorsAtom } from "../../../../services/atoms/collaborators.atoms";
import {
  newValidatePhone,
  validRut,
  validateEmail
} from "../../../../helpers/functions";
import { useEffect, useState } from "react";
import { useChargesAction } from "../../../../services/actions/charges.action";

const today = new Date().toISOString().split("T")[0];
const defaultDate = '1810-01-01T00:00:00.000Z'

const EditCollaboratorModal = ({
  open,
  toggle,
  submit,
  collaboratorHandler,
  clientId
}) => {
  const  {listCharges} =useChargesAction()
  const { collaborator, setCollaborator, isInternal, setInternal, } = collaboratorHandler;
  const collaboratorResolver = useRecoilValue(crudCollaboratorsAtom);
  const handleChange = (key, value) => setCollaborator((prevValues) => ({ ...prevValues, [key]: value }));
  const [phoneNumber, setPhoneNumber] = useState("")
  const [charges, setCharges] = useState([])

  const getCharges = async () => {
    const response = await listCharges({currentClientsId: clientId
     });
    setCharges(response?.data);
  };

  useEffect(()=>{
   getCharges()
   //eslint-disable-next-line
  }, [])

  useEffect(() => {
    collaborator?.collaboratorInternal === true
      ? setInternal(true)
      : setInternal(false);
      setPhoneNumber(collaborator?.phone)

      //eslint-disable-next-line
  }, []);

  return (
    <Modal isOpen={open} toggle={toggle}>
      <div className="gm-modal-header">
        <div className="gm-modal-title-container">
          <div className="gm-modal-title">Editar Colaborador</div>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={toggle}
        />
      </div>
      <ModalBody>
        <form onSubmit={submit}>
          <div className="gm-modal-form-container">
            <div className="gm-modal-form-section">
              <div className="gm-modal-form-group">
                <div className="gm-modal-input-group">
                  <label htmlFor="origenCollaborator">Origen Colaborador</label>
                  <select
                    value={isInternal}
                    onChange={() => {
                      setInternal(!isInternal);
                    }}
                    required
                  >
                    <option value={false}>Externo</option>
                    <option value={true}>Interno</option>
                  </select>
                </div>
              </div>
              <div className="gm-modal-form-group-grid">
                <div className="gm-modal-input-group">
                  <label htmlFor="name">
                    Nombre<span className="gm-span-required">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={collaborator?.name || ""}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </div>
                <div className="gm-modal-input-group ">
                  <label htmlFor="surname">
                    Apellido<span className="gm-span-required">*</span>
                  </label>
                  <input
                    type="text"
                    id="surname"
                    name="surname"
                    value={collaborator?.surname || ""}
                    onChange={(e) => handleChange("surname", e.target.value)}
                  />
                </div>
              </div>
              <div className="gm-modal-form-group-grid">
                <div className="gm-modal-input-group ">
                  <label htmlFor="rut">
                    RUT<span className="gm-span-required">*</span>
                  </label>
                  <Input
                    type="text"
                    id="rut"
                    name="rut"
                    onChange={(e) =>
                      handleChange("rut", cleanRut(e.target.value))
                    }
                    value={
                      collaborator?.rut ? formatRut(collaborator?.rut) : ""
                    }
                    invalid={
                      collaborator?.rut ? !validRut(collaborator?.rut) : false
                    }
                    maxLength={13}
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="birthDate">Fecha de nacimiento</label>
                  <input
                    value={
                      collaborator?.birthDate === defaultDate
                        ? ""
                        : collaborator?.birthDate?.split("T")[0]
                    }
                    type="date"
                    id="birthDate"
                    name="birthDate"
                    onChange={(e) => handleChange("birthDate", e.target.value)}
                    max={today}
                  />
                </div>
              </div>
              <div className="gm-modal-form-group-grid">
                <div className="gm-modal-input-group">
                  <label htmlFor="email">
                    Correo<span className="gm-span-required">*</span>
                  </label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    value={collaborator?.email || ""}
                    onChange={(e) => handleChange("email", e.target.value)}
                    maxLength={90}
                    invalid={validateEmail(collaborator?.email)}
                    required
                  />
                </div>
                <div className="gm-modal-input-group">
                  <label htmlFor="phone">Teléfono</label>
                  {/* <div className="gm-number-form">
                    <div>+56</div>
                    <Input
                      type="text"
                      id="phone"
                      name="phone"
                      value={phoneNumber}
                      onChange={(e) => {
                        handleChange("phone", e.target.value);
                        setPhoneNumber(e.target.value)
                      }}
                      maxLength={9}
                      invalid={
                        !validatePhone(phoneNumber)
                      }
                    />
                  </div> */}
                  <Input
                    type="text"
                    id="phone"
                    name="phone"
                    value={phoneNumber}
                    onChange={(e) => {
                      handleChange("phone", e.target.value);
                      setPhoneNumber(e.target.value);
                    }}
                    maxLength={20}
                    placeholder="+569 1234 5678"
                    invalid={!newValidatePhone(phoneNumber)}
                  />
                </div>
              </div>
              {isInternal === false && (
                <div className="gm-modal-form-group">
                  <div className="gm-modal-input-group">
                    <label htmlFor="position">Proceso de Evaluación: </label>
                    <select
                      name="position"
                      id="position"
                      value={collaborator?.position || ""}
                      onChange={(e) => handleChange("position", e.target.value)}
                    >
                      <option value={null}>Seleccionar</option>
                      {charges?.map((charges, index) => (
                        <option key={`key-${Date.now()}-${index}`} value={charges.name}>{charges.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
              {isInternal && (
                <div>
                  <div className="gm-modal-form-group-grid">
                    <div className="gm-modal-input-group ">
                      <label htmlFor="startDate">Inicio en la Empresa</label>
                      <input
                        type="date"
                        value={
                          collaborator?.startDate !== defaultDate
                            ? collaborator.startDate?.split("T")[0]
                            : ""
                        }
                        id="startDate"
                        name="startDate"
                        onChange={(e) =>
                          handleChange("startDate", e.target.value)
                        }
                        max={today}
                      />
                    </div>
                    <div className="gm-modal-input-group">
                      <label htmlFor="area">Área de trabajo</label>
                      <input
                        type="text"
                        id="area"
                        name="area"
                        value={collaborator?.area || ""}
                        onChange={(e) => handleChange("area", e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="gm-modal-buttons">
            <button
              type="button"
              className="gm-secondary-button"
              onClick={toggle}
            >
              Cancelar
            </button>
            <ButtonLoading
              className="gm-primary-button"
              type="submit"
              buttonLabel="Listo"
              disabled={
                !validRut(collaborator?.rut) ||
                validateEmail(collaborator?.email) ||
                collaboratorResolver.loading
              }
              loading={collaboratorResolver.loading}
            />
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default EditCollaboratorModal;
